import React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {ProfileCardCircle2} from '../../../assets/images';
import {stylePatterns} from '../../theme/patterns';
import {Image} from '../image';
import {Button} from '../button';
import {images} from '../../../assets/icons';
import {useBlockCardDialog} from '../../hooks/useBlockCardDialog';
import {useTheme} from '../../theme';
import {CardInfoCard} from './components/card';
import {CardInfoCardBlocked} from './components/cardBlocked';
import {Props as BaseProps} from './model';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpFontSize, VisImpStatus} from '../../models/visuallyImpairedSettings';

interface Props extends BaseProps {
  card?: string;
  dateUntil?: string;
  uscIsBlocked: boolean;
  isFinancial: boolean;
  isCampusParticipant: boolean;
}

const cardWidth = 316;
const cardHeight = 198;
const cardBlockedVisImpWidth = 383;
const cardBlockedVisImpHeight = 252;

export default ({dateUntil, card, uscIsBlocked, isFinancial, showBlockButton, isCampusParticipant}: Props) => {
  const theme = useTheme();
  const themeSettings = useSelector(themeSelector());
  const isVisImpActive = themeSettings.visuallyImpaired === VisImpStatus.Active;
  const isVisImpFontLarge = isVisImpActive && themeSettings.fontSize !== VisImpFontSize.Small;
  const styles = useStyles(() => ({
    wrap: {
      ...stylePatterns.flexCenterFull,
      position: 'relative',
      marginTop: -45,
    },
    tracery: {
      position: 'relative',
      color: theme.profileCard.traceryColor,
    },
    cardWrap: {
      marginTop: -40,
      marginLeft: 30,
      position: 'absolute',
      borderColor: theme.profileCard.cardBorderColor,
      borderWidth: 1,
      paddingHorizontal: 10,
      paddingVertical: 10,
      width: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpWidth : cardWidth,
      minHeight: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpHeight : cardHeight,
      flex: 1,
      backgroundColor: theme.profileCard.cardBackground,
      borderRadius: 10,
      ...theme.profileCard.cardWrapShadow,
    },
    button: {
      margin: 0,
      position: 'absolute',
      left: 0,
      bottom: -70,
      width: isVisImpFontLarge && uscIsBlocked ? cardBlockedVisImpWidth : cardWidth,
    },
    buttonIcon: {
      color: theme.color.primaryColor,
    },
  }));

  const showBlockCardDialog = useBlockCardDialog();

  return (
    <View style={styles.wrap}>
      <View style={styles.tracery}>
        <Image source={ProfileCardCircle2 as any} width={415} height={426} style={{width: 415, height: 426}} />
      </View>
      <View style={styles.cardWrap}>
        {uscIsBlocked ? (
          <CardInfoCardBlocked />
        ) : (
          <>
            <CardInfoCard dateUntil={dateUntil} card={card} isCampusParticipant={isCampusParticipant} />
            {!isFinancial && showBlockButton && (
              <Button
                id='block-card'
                type='secondary'
                text='Заблокировать карту'
                icon={images.Lock}
                iconPosition='left'
                style={styles.button}
                iconProps={{color: styles.buttonIcon.color}}
                onPress={showBlockCardDialog}
              />
            )}
          </>
        )}
      </View>
    </View>
  );
};
